import React from 'react'

const MainButton = ({title, onClick, className = ''}) => {
  return (
    <div>
        <button onClick={onClick} className={`text-white transition ease-in-out duration-300 group-hover:text-white group-hover:bg-purple hover:bg-white border border-purple py-1 px-4 rounded-[20px] ${className}`}>
            {title}
        </button>
    </div>
  )
}

export default MainButton